@use "@fukuri-admins/ui/layout" as *;

// フォームタイトル（ClientContractTermCreate と同パターン）
.formTitle {
  @include typography("Jp/20_W6");
  color: text("High");
}

// フォームフィールド群コンテナ（セクション間 gap 32px）
// 下部固定アクションバーが重なるため margin-bottom で余白を確保
.fieldSections {
  margin-bottom: spacing('88');
}

// 幅 172px 固定フィールドコンテナ（郵便番号・都道府県）
.field172 {
  width: 172px;

  > * {
    white-space: nowrap;
  }
}

// 利用予定者数フィールド（幅 126px 固定）
.employeeCountField {
  width: 126px;

  > * {
    white-space: nowrap;
  }
}

// 市区町村フィールド（横並び内で可変幅）
.cityField {
  flex: 1 0 0;
  min-width: 0;
}

// ボトムアクションバー（Figma: Admin / Parts / BottomActionButton）
// 画面下部に固定、上ボーダー・白背景
.bottomActionBar {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: background('Primary');
  border-top: 1px solid border('Tertiary');
  padding: spacing('16') 0;
}
